import { useQuery } from 'react-query'
import { BASE_API_URL } from 'constants/env'
import { API_METHODS } from 'constants/api-methods'
import { apiHeaders } from 'utils/api-headers'
import { store } from 'index'
import { handleErrors } from 'utils/handle-errors'
import { ID } from 'utils/types'
import { PageTemplate } from 'interfaces/page-template'

interface ResponseData {
  data: {
    page_templates: PageTemplate[]
  }
}

const fetchPageTemplates = async (orgId?: ID) => {
  try {
    let response = await fetch(
      `${BASE_API_URL}/api/v3/organizations/${orgId}/page_templates`,
      {
        method: API_METHODS.GET,
        headers: apiHeaders(store.getState()),
      }
    )
    response = handleErrors(response)
    const json: ResponseData = await response.json()
    return json.data.page_templates
  } catch (error) {
    console.error('error', error)
  }
}

export const useOrganizationPageTemplates = (orgId?: ID) => {
  return useQuery(
    [`/api/v3/organizations/${orgId}/page_templates`],
    () => fetchPageTemplates(orgId),
    {
      enabled: !!orgId,
    }
  )
}
